import React, { Component } from "react";

export default class Stats extends Component {
  renderStats = () => {
    const statsView: any[] = [];
    const stats = [
      { title: "Launched", results: "April 2021" },
      { title: "Users", results: "300,000" },
      { title: "Deployed Volunteers", results: "10,000" },
    ];

    stats.map((eachStats, key) => {
      statsView.push(
        <div className="mt-4 font-body flex flex-col" key={key}>
          <dt className="order-2 mt-2 text-lg leading-6 font-bold text-red-600">
            {eachStats.title}
          </dt>
          <dd className="order-1 text-4xl font-extrabold text-gray-700">
            {eachStats.results}
          </dd>
        </div>
      );
      return null;
    });

    return statsView;
  };

  render() {
    return (
      <div className="w-full bg-gray-50">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8 lg:py-20">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-extrabold text-red-600 sm:text-4xl">
              Stats from MyVac/MySukarela
            </h2>
          </div>
          <dl className="mt-10 text-center sm:max-w-3xl sm:mx-auto sm:grid sm:grid-cols-3 sm:gap-8">
            {this.renderStats()}
          </dl>
        </div>
      </div>
    );
  }
}
